var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 75,
    viewBox: "0 0 80 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 79.2253,
    height: 75,
    rx: 14,
    fill: "#5A47AB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7198 7C36.6531 7 33.9445 7.64563 31.594 8.93687C29.2435 10.2281 27.4071 12.0433 26.085 14.3826C24.7444 16.7218 39.7197 31.1032 39.7197 34.2284L39.7198 67.2113L29.0323 48.2637V23.0002C29.0323 20.4739 29.574 18.3686 30.6575 16.6843C31.7225 15.0188 33.0814 13.7744 34.7341 12.951C36.3685 12.1275 38.0304 11.7159 39.7198 11.7159C41.3909 11.7159 43.0528 12.1182 44.7055 12.9229C46.3398 13.7463 47.6987 14.9907 48.7822 16.6563C49.8656 18.3405 50.4073 20.4551 50.4073 23.0002V48.2637L39.7198 67.2113L39.7197 34.2284C39.7197 31.0845 54.7044 16.6937 53.3822 14.3545C52.0417 12.034 50.1962 10.2281 47.8456 8.93687C45.4951 7.64563 42.7865 7 39.7198 7Z",
    fill: "#FBD15B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg);
export default __webpack_public_path__ + "static/media/Img.db36485cf60f98791af1e72d5a0029ec.svg";
export { ForwardRef as ReactComponent };